import Style from "./index.module.css";

export default function Stepper({ steps, currentStep, onStepClick }) {
    return (
        <div>
            <div className={Style.stepper} role="tablist" aria-label="Progresso do cadastro">
                {steps.map((label, idx) => {
                    const n = idx + 1;
                    const isActive = n === currentStep;
                    const isCompleted = n < currentStep;

                    return (
                        <div className={Style.stepperSegment} key={label}>
                            <button
                                type="button"
                                className={[
                                    Style.stepCircle,
                                    isActive ? Style.active : "",
                                    isCompleted ? Style.completed : "",
                                ].join(" ")}
                                aria-current={isActive ? "step" : undefined}
                                onClick={() => {
                                    if (onStepClick && n < currentStep) onStepClick(n);
                                }}
                                disabled={!(onStepClick && n < currentStep)}
                                title={label}
                            >
                                {isCompleted ? "✓" : n}
                            </button>
                            <span className={Style.stepLabel}>{label}</span>
                            {idx < steps.length - 1 && (
                                <div
                                    className={[
                                        Style.connector,
                                        isCompleted ? Style.completed : "",
                                    ].join(" ")}
                                    aria-hidden="true"
                                />
                            )}
                        </div>
                    );
                })}
            </div>
            {/* 
            <div className={Style.progressTrack} aria-hidden="true">
                <div
                    className={Style.progressFill}
                    style={{
                        width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
                    }}
                />
            </div> */}
        </div>
    );
}
